import {
  Box,
  Button,
  FormControl,
  Input,
  Spinner,
  Text,
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

export const Modal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    const modalShown = localStorage.getItem("modalShown");

    if (!modalShown) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        localStorage.setItem("modalShown", "true");
      }, 60000); // 10 segundos para mostrar el modal

      return () => clearTimeout(timer);
    }
  }, []);

  const isValidEmail = () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleClose = () => {
    setIsOpen(false);
    setEmail("");
    setShowMessage(false);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("/api/users", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          fecha: new Date(),
        }),
      });

      const data = await response.json();
      console.log("info modal:", data);

      setEmail("");
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
        setIsOpen(false);
      }, 2000);
    } catch (error) {
      console.error("Error submitting the form:", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <ChakraModal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="2xl" boxShadow="xl" p="4">
        <ModalHeader fontSize="2xl" textAlign="center">
          ¡Hola! Be the first to know.
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontSize="md" mb="4" textAlign="center">
            Group classes and webinars are coming soon! ❤️
          </Text>

          {showMessage ? (
            <Box
              mb="4"
              bg="green.400"
              color="white"
              p="3"
              borderRadius="md"
              textAlign="center"
            >
              <Text fontSize="sm">Email sent! Check your inbox 📬</Text>
            </Box>
          ) : (
            <form onSubmit={handleSubmit}>
              <FormControl mb="3">
                <Input
                  value={email}
                  onChange={handleEmailChange}
                  type="email"
                  placeholder="Write here your email"
                  borderRadius="xl"
                  size="lg"
                />
              </FormControl>
              {email && !isValidEmail() && (
                <Text fontSize="sm" color="red.500" mb="2">
                  That doesn’t look like a valid email.
                </Text>
              )}
              <Button
                type="submit"
                colorScheme="green"
                isDisabled={!isValidEmail()}
                isLoading={loading}
                loadingText="Conjugating verbs..."
                spinner={<Spinner size="sm" />}
                spinnerPlacement="end"
                width="100%"
                size="lg"
                borderRadius="xl"
              >
                Let’s go!
              </Button>
            </form>
          )}

          {/* Texto debajo del formulario */}
          <Text
            fontSize="md"
            mt="4"
            textAlign="center"
            color="gray.500"
            fontStyle="italic"
          >
            Todo bueno. Nada spam. ✨
          </Text>
        </ModalBody>
      </ModalContent>
    </ChakraModal>
  );
};
